import { App } from 'vue';
import * as components from './all';
import vSelect from 'vue-select';
import { Splitpanes, Pane } from 'splitpanes';
import {
  Components as BvnComponents,
  createBootstrap,
  vBTooltip,
} from 'bootstrap-vue-next';
import './all.scss';

export default function installComponents(app: App) {
  app.use(
    createBootstrap({ components: { BDropdown: { strategy: 'fixed' } } }),
  );
  for (const name in BvnComponents) {
    app.component(name, BvnComponents[name]);
  }

  app.directive('b-tooltip', vBTooltip);

  app.component('VSelect', vSelect);
  app.component('Splitpanes', Splitpanes);
  app.component('Pane', Pane);

  for (const componentName in components) {
    app.component(componentName, components[componentName]);
  }
}
